import React, { useState, useCallback } from 'react';
import LogDose from './LogDose';
import Calendar from './Calendar';
import Streaks from './Streaks';
import { api } from '../api';
import toast from 'react-hot-toast';

export default function MemberView({ currentUser }) {
  const [refreshKey, setRefreshKey] = useState(0);

  const handleLogged = useCallback(() => {
    setRefreshKey(k => k + 1);
  }, []);

  function handleExport() {
    api.exportCSV(null, currentUser.name)
      .catch(() => toast.error('Export failed'));
  }

  return (
    <div className="member-view">
      <LogDose userId={null} onLogged={handleLogged} />
      <Streaks key={refreshKey} userId={null} />
      <Calendar key={`cal-${refreshKey}`} userId={null} />
      <div className="export-row">
        <button className="btn-secondary" onClick={handleExport}>⬇ Export My History (CSV)</button>
      </div>
    </div>
  );
}
